import { StatusBadge } from './StatusBadge';
import {
  phaseLabel,
  phaseOf,
  phaseTone,
  timeAgo,
  type ApiValidation,
  type VerificationViewDoc,
} from '../lib/verificationView';

/** One specialist's official-source check, live: phase badge, review flag, when, and a details toggle. */
export function OfficialCheckCell({
  view,
  apiValidation,
  name,
  open,
  onToggle,
}: {
  view: VerificationViewDoc | null | undefined;
  apiValidation?: ApiValidation | null;
  /** Specialist name, for the Details button's accessible label. */
  name?: string;
  open: boolean;
  onToggle: () => void;
}) {
  const phase = phaseOf(view, apiValidation);
  const needsReview = view?.needsAdminReview ?? apiValidation?.needsAdminReview ?? false;
  const verifyManually = phase === 'manual_review' || phase === 'inconclusive';
  const checkedAt = view?.lastCheckedAt ?? apiValidation?.lastCheckedAt;
  // A queued job shows its age: nothing else tells an admin that it has been sitting there.
  const checked = phase === 'queued' ? '' : timeAgo(checkedAt);
  const queuedFor = phase === 'queued' ? timeAgo(view?.updatedAt) : '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', alignItems: 'flex-start' }}>
      <span style={{ display: 'inline-flex', gap: '0.25rem', flexWrap: 'wrap' }}>
        <StatusBadge label={phaseLabel(phase)} tone={phaseTone(phase)} />
        {needsReview && <StatusBadge label="Needs review" tone="bad" />}
      </span>
      {queuedFor && <small style={{ opacity: 0.7 }}>queued {queuedFor}</small>}
      {checked && <small style={{ opacity: 0.7 }}>checked {checked}</small>}
      {view && (
        <button
          type="button"
          className="btn"
          aria-expanded={open}
          aria-label={name ? `${open ? 'Hide details' : 'Details'} for ${name}` : undefined}
          onClick={onToggle}
        >
          {open ? 'Hide details' : verifyManually ? 'Verify manually' : 'Details'}
        </button>
      )}
    </div>
  );
}
